import "./upgrade.scss";
import { useState, useEffect } from "react";
import { TextField, Alert, Button } from "@mui/material";
import axios from "axios";
import { loadStripe } from "@stripe/stripe-js";
import detailList from "../../utils/tickets.json";
import { Percent } from "@mui/icons-material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from "@stripe/react-stripe-js";
import eliteSeating from "../../images/elite_sitting.webp";
import vip from "../../images/vip.webp";
import netwroking from "../../images/networking.webp";
import close from "../../images/closeStage.webp";
import dinner from "../../images/vipDinner.webp";
import evening from "../../images/vipEvening.webp";
import speaking from "../../images/speaker.webp";
import record from "../../images/recordings.webp";
import banner from "../../images/SBCBanner.webp";
const stripePromise = await loadStripe("pk_live_aRr3qYrpVTbyNgBbB7t0jqiy");
// const stripePromise = await loadStripe("pk_test_HGDc5rMpzlE4NJvFygwF1zIW");

export default function Upgrade() {
  const [tickets, setTickets] = useState([]);
  const [liveEvent, setLiveEvent] = useState(false);
  const [email, setEmail] = useState("");
  const [emailTickets, setEmailTickets] = useState([]);
  const [ticket, setTicket] = useState("");
  const [attendee, setAttendee] = useState({});
  const [upgradeArray, setUpgradeArray] = useState([]);
  const [showUpgrade, setShowUpgrade] = useState(false);
  const [showPayment, setShowPayment] = useState(false);
  const [options, setOptions] = useState({});
  const [prevTicket, setPrevTicket] = useState("");
  const [chosenUpgradeTicket, setChosenUpgradeTicket] = useState("");
  const [upgradePrice, setUpgradePrice] = useState("");
  let previousBenefits = new Set();
  //alertss
  const [showUpgradeAlert, setShowUpgradeAlert] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  // const url = "http://localhost:4100";
  const url = "https://dev.pmwevents.com";

  //THIS GETS TICKETS FOR A SPECIFIC EVENT
  //THIS USEEFFECT WILL TRIGGER THE GET EVENT TICKETS
  useEffect(() => {
    let id = localStorage.getItem("sbcTicket");

    axios
      .get(`${url}/sbc/get-active-sbc`)
      .then((res) => {
        setLiveEvent(true);
        getEvent(res.data[0].eventId);
      })
      .catch((err) => {
        console.log("Could not get active SBC events");
      });
  }, []);

  const getEvent = async (id) => {
    localStorage.setItem("eventId", id);
    const eventId = {
      event: id,
    };
    await axios
      .post(`${url}/sbc/get-sbc-not-all`, eventId)
      .then((res) => {
        let _tickets = [];

        res.data.forEach((ticket) => {
          const matchingSpec = detailList[ticket.ticketName];
          if (matchingSpec) {
            _tickets.push({ ...ticket, specs: matchingSpec });
          }
        });

        setTickets(_tickets);
      })
      .catch((err) => {
        console.log(err);
        console.log("Could not get details of SBC Event");
      });
  };

  const handleUpgradeSelect = async (ticketName, ticketPrice) => {
    let _paidAmount = (attendee.paidAmount / 120) * 100;
    let _toPay = ticketPrice - _paidAmount;
    _toPay = parseFloat((_toPay * 1.2).toFixed(2));
    setChosenUpgradeTicket(ticketName);
    setUpgradePrice(_toPay);
  };

  const checkUpgrade = async (attId) => {
    if (attId === "") {
      setMessage(
        "Please insert a valid ticket number, you can find it on your email"
      );
      setSeverity("warning");
      setShowUpgradeAlert(true);
      setTimeout(() => {
        setShowUpgradeAlert(false);
      }, 2500);
    } else {
      await axios
        .post(`${url}/sbc/check-upgrade`, { ticket: attId })
        .then((res) => {
          setAttendee(res.data.attendee);
          setPrevTicket(res.data.attendee.ticketType.slice(4));
          setShowUpgrade(true);
        })
        .catch((err) => {
          console.log(err);
          if (err.response.status === 303) {
            setMessage(err.response.data.msg);
            setSeverity("error");
            setShowUpgradeAlert(true);
            setTimeout(() => {
              setShowUpgradeAlert(false);
            }, 2500);
          } else {
            setMessage("Something went wrong, please try again");
            setSeverity("error");
            setShowUpgradeAlert(true);
            setTimeout(() => {
              setShowUpgradeAlert(false);
            }, 2500);
          }
        });
    }
  };

  const handleCheckout = async () => {
    let reqBody = {
      prevTicket: prevTicket,
      ticket: `SBC-${chosenUpgradeTicket}`,
      attendee: attendee.attendeeId,
      paidAmount: upgradePrice,
      attendeeInfo: {
        firstName: attendee.name,
        lastName: attendee.lastName,
        email: attendee.email,
      },
    };

    await axios
      .post(`${url}/sbc/upgrade-secret`, reqBody)
      .then((res) => {
        setOptions({ clientSecret: res.data.clientSecret });
        setShowPayment(true);
        window.scrollTo(0, 0);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const searchEmails = async () => {
    setEmailTickets([]);
    setTicket("");
    await axios
      .post(`${url}/sbc/get-tickets-by-email`, { email: email })
      .then(async (res) => {
        let filteredTickets = res.data.tickets.filter((t) => {
          return t.ticketType !== "SBC-Elite";
        });

        if (filteredTickets.length == 0) {
          setMessage("No upgradable tickets");
          setSeverity("error");
          setShowUpgradeAlert(true);
          setTimeout(() => {
            setShowUpgradeAlert(false);
          }, 2500);
        } else if (filteredTickets.length == 1) {
          setTicket(filteredTickets[0].attendeeId);
          checkUpgrade(filteredTickets[0].attendeeId);
        } else {
          setEmailTickets(filteredTickets);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const scrollTo = (id) => {
    document.getElementById(id).scrollIntoView();
  };

  return (
    <main className="upgrade__main">
      <img src={banner} width="100%" alt="Speaker Banner" className="banner" />
      <section className="upgrade-copy">
        <h2>You’ve Got the Ticket</h2>
        <h3>Now Claim the Experience</h3>
        <p>
          For the next 48 hours only, you have private access to upgrade your
          ticket at the lowest price these seats will ever be offered.
        </p>
        <p>
          When these tiers are released to the public, the price will rise. And
          with the limited seats at the VIP and Elite brackets, there{" "}
          <strong>may not be any left to release at all.</strong>
        </p>
        <section className="upgrade__columns">
          <img src={eliteSeating} alt="Elite tickets seating" />
          <section className="column">
            <h3>Upgrading is about the environment</h3>
            <p>Where you sit, shapes what you hear.</p>
            <p>Who you meet, changes how you think.</p>
            <h4>And what upgrade you choose decides both of those!</h4>
            <button
              className="upgrade__page--btn"
              onClick={() => scrollTo("upgrade-input")}
            >
              Upgrade Now
            </button>
          </section>
        </section>
        <section className="icons">
          <h3>Upgrading is about access and impact</h3>
          <section className="img--row">
            <p className="row--p">
              <strong>Private networking access</strong>
              <br />
              Space to connect with the right people, without the crowd
            </p>

            <img src={netwroking} alt="networking night with speakers" />
          </section>
          <section className="img--row">
            <p className="row--p">
              <strong>Proximity to the action</strong>
              <br />
              The energy and insights hit harder when you’re closer to the
              stage, seated at your own table
            </p>
            <img src={close} alt="Close to the stage" />
          </section>
          <section className="img--row">
            <p className="row--p">
              <strong>VIP Evening Access</strong>
              <br />
              An evening designed for conversations and fresh ideas with the
              right people
            </p>
            <img src={evening} alt="Vip evening" />
          </section>
          <section className="img--row">
            <p className="row--p">
              <strong>Speaker access beyond the stage</strong>
              <br />
              Engage with the people, not just the presentations
            </p>
            <img src={speaking} alt="Speaker access" />
          </section>
          <section className="img--row">
            <p className="row--p">
              <strong>Elite Dinner Invitation</strong> <em>(Elite only)</em>
              <br />
              An intimate evening with select speakers and influential guests
              shaping the future of business in Scotland
            </p>
            <img src={dinner} alt="Elite dinner" />
          </section>
          <section className="img--row">
            <p className="row--p">
              <strong>Full session recordings and exclusive resources</strong>{" "}
              <em>(Elite only)</em>
              <br />
              Revisit the breakthroughs and apply them long after the event
            </p>
            <img src={record} alt="Recordings to watch on your own time" />
          </section>
          <button
            className="upgrade__page--btn"
            onClick={() => scrollTo("upgrade-input")}
          >
            Upgrade Now
          </button>
        </section>
        <section className="upgrade__columns">
          <section className="column">
            <h3>Upgrading is about intention</h3>
            <p>
              If you know that you're not here just to take part, but to
              accelerate what you’ve already started, this is the moment to back
              that decision.
            </p>
            <p>
              You’re putting yourself in the conversations, the environments,
              and the energy that make results inevitable.
            </p>
          </section>
          <img src={vip} alt="vip ticket access" />
        </section>
        <h4>Upgrade now.</h4>
        <h4> Claim the experience of SBC you were made for.</h4>
      </section>
      {!showPayment ? (
        !showUpgrade ? (
          //!THE BELOW IS FOR WHEN THE CLIENT IS USING THEIR EMAIL
          <>
            <TextField
              id="upgrade-input"
              label="Your Email Address"
              variant="outlined"
              onChange={(e) => setEmail(e.target.value)}
              className="ticket-number-input"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  searchEmails();
                }
              }}
            />
            {!showUpgradeAlert ? (
              <button className="upgrade--btn" onClick={searchEmails}>
                Check For Upgrade
              </button>
            ) : (
              <Alert severity={severity} sx={{ margin: "2% auto" }}>
                {message}
              </Alert>
            )}
            {emailTickets.length > 0 ? (
              <>
                <select
                  value={ticket}
                  className="select-email"
                  onChange={(e) => setTicket(e.target.value)}
                >
                  <option>Please select the ticket you wish to upgrade</option>
                  {emailTickets.map((t, i) => {
                    return (
                      <option value={t.attendeeId} key={i}>
                        {t.name} - {t.ticketType}
                      </option>
                    );
                  })}
                </select>
                <button
                  className="upgrade--btn"
                  onClick={() => checkUpgrade(ticket)}
                >
                  Upgrade Selected Ticket
                </button>
              </>
            ) : null}
          </>
        ) : (
          <section className="upgrade">
            <section className="upgrade__card">
              <h4>
                {attendee.name.toUpperCase()} {attendee.lastName.toUpperCase()}
              </h4>
              <h5>
                Your current ticket:{" "}
                <span className="ticket_level">
                  {attendee.ticketType.slice(4)}
                </span>
              </h5>
            </section>
            <section className="ticket_options">
              {attendee.ticketType != "SBC-General" &&
              attendee.ticketType != "SBC-VIP" ? (
                <h2>This Ticket Type is not upgradable</h2>
              ) : (
                tickets.map((t, index) => {
                  let backgroundColour,
                    fontColor,
                    text,
                    prev,
                    ticSold = "",
                    disabled = false;
                  //DO NOT SHOW ANYTHING BUT VIP AND ELITE
                  if (
                    t.ticketName === "Elite" ||
                    t.ticketName === "Inner Circle"
                  ) {
                    return;
                  }
                  //SORT THE RELEVANT TICKET SPECS
                  const currentBenefits = Object.values(
                    detailList[t.ticketName][0]
                  );
                  const uniqueBenefits = currentBenefits.filter(
                    (b) => !previousBenefits.has(b)
                  );
                  currentBenefits.forEach((b) => previousBenefits.add(b));
                  //SORT BACKGROUND COLOURS
                  if (t.ticketName === "VIP") {
                    backgroundColour = "#93E3D3";
                    fontColor = "#0e2f35";
                    text = "MOST POPULAR";
                    prev = "£799 + VAT";
                    ticSold = "72% Sold";
                  } else {
                    backgroundColour = "#0e2f35";
                    fontColor = "#fff";
                    text = "";
                    prev = "£1599 + VAT";
                    ticSold = "15 Tickets Left";
                  }
                  const firstMatchIndex = tickets.findIndex(
                    (ti) => ti.ticketName === prevTicket
                  );
                  if (index > firstMatchIndex && t.ticketName !== prevTicket) {
                    return (
                      <div
                        key={index}
                        className="ticket-type-card"
                        style={{
                          backgroundColor: backgroundColour,
                          color: fontColor,
                        }}
                      >
                        <div className="content-section">
                          <p style={{ minHeight: "1.2rem" }} className={t.ticketName}>
                            {text}
                          </p>
                          <h2>{t.ticketName}</h2>
                          <h6>
                            £
                            {(
                              Number(t.ticketPrice) -
                              Number(attendee.paidAmount / 1.2)
                            ).toFixed(2)}
                            <span> + VAT</span>
                          </h6>

                          <hr
                            style={{
                              border: `2px solid ${fontColor}`,
                              marginTop: `2rem`,
                              marginBottom: `2rem`,
                            }}
                          />

                          <ul>
                            {index > 0 && (
                              <li
                                className={`${t.name}-entry`}
                                style={{
                                  color: fontColor,
                                  alignSelf: "flex-start",
                                  marginLeft: 0,
                                  justifyContent: "flex-start",
                                }}
                              >
                                <CheckCircleIcon className="icon" />
                                Everything in previous tier plus:
                              </li>
                            )}
                            {uniqueBenefits.map((benefit, i) => (
                              <li
                                key={i}
                                className={`${t.name}-entry`}
                                style={{ color: fontColor }}
                              >
                                <CheckCircleIcon className="icon" />
                                {benefit}
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div className="bottom-section">
                          <p className="tickets-sold">{ticSold}</p>
                          <p className="percent-sold">
                            {t.percentageSold ? (
                              <>
                                {t.percentageSold}
                                <Percent /> SOLD
                              </>
                            ) : null}
                          </p>
                          <Button
                            className="ticket-card-button"
                            variant="contained"
                            onClick={() => {
                              handleUpgradeSelect(t.ticketName, t.ticketPrice);
                            }}
                            disabled={
                              t.ticketName === chosenUpgradeTicket ||
                              t.ticketSales == t.maxTickets ||
                              disabled
                            }
                          >
                            {t.ticketSales == t.maxTickets
                              ? "Sold out"
                              : t.ticketName === chosenUpgradeTicket
                              ? "Selected"
                              : "UPGRADE"}
                          </Button>
                        </div>
                      </div>
                    );
                  }
                  return null;
                })
              )}
            </section>

            {chosenUpgradeTicket !== "" ? (
              <section className="confirm-ticket">
                <h2>
                  You have chosen to upgrade to the{" "}
                  <span>{chosenUpgradeTicket}</span> ticket.
                </h2>
                <Button className="submit_btn" onClick={handleCheckout}>
                  Proceed to Checkout
                </Button>
              </section>
            ) : null}
          </section>
        )
      ) : (
        <div className="payment-portal" style={{ marginTop: "5vh" }}>
          <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
            <EmbeddedCheckout />
          </EmbeddedCheckoutProvider>
        </div>
      )}
    </main>
  );
}

// <>
//   <TextField
//     id="outlined-basic"
//     label="Your Ticket Number"
//     variant="outlined"
//     onChange={(e) => setTicket(e.target.value)}
//     className="ticket-number-input"
//     onKeyDown={(e) => {
//       if (e.key === "Enter") {
//         checkUpgrade(ticket);
//       }
//     }}
//   />
//   {!showUpgradeAlert ? (
//     <button
//       className="upgrade--btn"
//       onClick={() => checkUpgrade(ticket)}
//     >
//       Check For Upgrade
//     </button>
//   ) : (
//     <Alert severity={severity} sx={{ margin: "2% auto" }}>
//       {message}
//     </Alert>
//   )}
// </>
